import React from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery, useTheme } from '@mui/material';

const isDevMode = process.env.NODE_ENV === 'development';

function useWindowSize() {
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return size;
}

export default function DevScreenSizeOverlay() {
  const theme = useTheme();
  const { width, height } = useWindowSize();
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  if (!isDevMode) {
    return null;
  }

  const breakpoint = isXl ? 'xl' : isLg ? 'lg' : isMd ? 'md' : isSm ? 'sm' : 'xs';

  return (
    <Box
      sx={{
        position: 'fixed',
        right: 12,
        bottom: 12,
        zIndex: theme.zIndex.tooltip + 1000,
        px: 1.5,
        py: 1,
        borderRadius: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.78)',
        color: '#fff',
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        letterSpacing: 0,
        pointerEvents: 'none',
      }}
    >
      {breakpoint} | {width}x{height}
    </Box>
  );
}
